import { Link } from "react-router-dom";

import { SEVERIDADES, type AlertasResumo } from "../../lib/dashboard/tipos";
import { corSeveridade, rotuloSeveridade } from "./severidade";

/*
 * Bloco de alertas ativos do dashboard (Tela 1). Cabeçalho "Alertas ativos" + a
 * contagem total em destaque, a lista por severidade (informativa..critica, na
 * ordem da tupla `SEVERIDADES`, cada uma com cor mapeada aos tokens CPMH), a
 * `max_severidade` destacada como badge, e um link "Ver alertas" → histórico.
 *
 * SEM alertas ativos (`total_ativos === 0`) → "Nenhum alerta ativo." (e sem
 * lista/badge). As cores e rótulos vêm de `./severidade` (fonte única). Só
 * tokens CPMH.
 */

interface AlertasBlocoProps {
  alertas: AlertasResumo;
}

export function AlertasBloco({ alertas }: AlertasBlocoProps): JSX.Element {
  return (
    <section className="rounded-lg border border-platinum bg-snow p-4">
      <div className="flex items-baseline justify-between">
        <h2 className="font-subtitulo text-base text-off-black">
          Alertas ativos
        </h2>
        <Link to="/historico/alertas" className="text-flame hover:underline">
          Ver alertas
        </Link>
      </div>

      <p className="font-titulo text-2xl text-off-black">
        {alertas.total_ativos}
      </p>

      {alertas.total_ativos === 0 ? (
        <p className="font-corpo text-base text-off-black">
          Nenhum alerta ativo.
        </p>
      ) : (
        <>
          <ul className="flex flex-col gap-1">
            {SEVERIDADES.map((severidade) => (
              <li
                key={severidade.valor}
                className={`font-corpo text-base ${corSeveridade(
                  severidade.valor,
                )}`}
              >
                {severidade.rotulo}: {alertas.por_severidade[severidade.valor]}
              </li>
            ))}
          </ul>

          {alertas.max_severidade !== null && (
            <p className="font-corpo text-base text-off-black">
              Severidade máxima:{" "}
              <span
                className={`font-subtitulo ${corSeveridade(
                  alertas.max_severidade,
                )}`}
              >
                {rotuloSeveridade(alertas.max_severidade)}
              </span>
            </p>
          )}
        </>
      )}
    </section>
  );
}
